import { useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";

// Componentes de Argon
import BottomTabBar from "components/BottomTabBar";
import { useArgonController } from "context";
import { AuthProvider } from "context/AuthContext";
import { UserProvider } from "context/UserContext";
import { LanguageProvider } from "context/LanguageContext";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import themeRTL from "assets/theme/theme-rtl";

// Rutas
import routes from "routes";




export default function App() {
  const [controller] = useArgonController();
  const { direction, darkMode } = controller;
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Suprimir errores de ResizeObserver
  useEffect(() => {
    const originalError = console.error;
    console.error = (...args) => {
      if (
        args[0] &&
        typeof args[0] === "string" &&
        args[0].includes("ResizeObserver loop completed with undelivered notifications")
      ) {
        return; // Suprime este error específico
      }
      originalError(...args); // Otros errores permanecen visibles
    };
  }, []);

  // Crear cache para RTL
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Cambiar atributo `dir` del body
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Scroll al cambiar de ruta
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // Renderizar rutas
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }
      return null;
    });

  // Renderizar Bottom Tab Bar - mostrar en todas las rutas excepto login
  const renderBottomTabBar = () => {
    // No mostrar BottomTabBar en la página de login
    if (pathname === "/authentication/sign-in") {
      return null;
    }
    return <BottomTabBar />;
  };
  

  return (
    <AuthProvider>
      <UserProvider>
        <LanguageProvider>
        {direction === "rtl" ? (
          <CacheProvider value={rtlCache}>
            <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
              <CssBaseline />
              {renderBottomTabBar()}
              <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<Navigate to="/disponibilidad" />} />
              </Routes>
            </ThemeProvider>
          </CacheProvider>
        ) : (
          <ThemeProvider theme={darkMode ? themeDark : theme}>
            <CssBaseline />
            {renderBottomTabBar()}
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/disponibilidad" />} />
            </Routes>
          </ThemeProvider>
        )}
        </LanguageProvider>
      </UserProvider>
    </AuthProvider>
  );
}
